var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedesInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#27365d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "redes-instagram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "redes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg-instagram"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.88,9A3.12,3.12,0,1,0,43,12.12,3.12,3.12,0,0,0,39.88,9ZM26,34.67A8.67,8.67,0,1,1,34.67,26,8.67,8.67,0,0,1,26,34.67Zm0-22A13.35,13.35,0,1,0,39.35,26,13.35,13.35,0,0,0,26,12.65ZM26,0c-7.06,0-7.95,0-10.72.16C5.84.59.59,5.83.16,15.28,0,18.05,0,18.94,0,26s0,8,.16,10.72c.43,9.44,5.67,14.69,15.12,15.12C18.05,52,18.94,52,26,52s8,0,10.72-.16c9.43-.43,14.7-5.67,15.12-15.12C52,34,52,33.06,52,26s0-7.95-.16-10.72C51.42,5.85,46.17.59,36.72.16,34,0,33.06,0,26,0Zm0,4.69c6.94,0,7.77,0,10.51.15,7,.32,10.33,3.66,10.66,10.65.12,2.75.15,3.57.15,10.51s0,7.77-.15,10.51c-.33,7-3.61,10.33-10.66,10.66-2.74.12-3.57.15-10.51.15s-7.77,0-10.51-.15C8.43,46.84,5.16,43.49,4.84,36.51c-.13-2.74-.16-3.57-.16-10.51s0-7.76.16-10.51c.32-7,3.6-10.33,10.65-10.65,2.75-.13,3.57-.15,10.51-.15Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedesInstagram);
export default __webpack_public_path__ + "static/media/redes-instagram.3ee607c466daf48f9424ec62398654a4.svg";
export { ForwardRef as ReactComponent };